import { CustomerPrepayOnlyByMatchQuery } from '@water-web/api';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CustomerServiceConstructor = (apiUrl: string) => ({
  prepayOnlyByMatch: new CustomerPrepayOnlyByMatchQuery(apiUrl),
});
